import TextField from "./TextField";
import CustomSelect from "./Select";
import RadioGroup from "./RadioGroup";
import FormCheckbox from "./Checkbox";
import CheckboxGroup from "./Checkbox/index2";
import FormSwitch from "./Switch";
import FormDatePicker from "./Datepicker";
import FormTimePicker from "./Timepicker";
import Button from "./Button";
import Autocomplete from "./AutoComplete";

const Controls = {
  TextField,
  CustomSelect,
  RadioGroup,
  FormCheckbox,
  CheckboxGroup,
  FormSwitch,
  FormDatePicker,
  FormTimePicker,
  Button,
  Autocomplete,
};

export default Controls;
